// If you want the environment variable imported somewhere:

// - Add the env var to the Circle CI project: https://app.circleci.com/settings/project/github/trex-arms/trex/environment-variables
// - Edit shared/valid_environment_variables.mjs

// - Into api: Add the env var to "export const environment_variables_copied_to_api"
// - Into taskmaster: Add the env var to "export const environment_variables_copied_to_taskmaster"
// - Into a CF worker: Add the env var to "export const environment_variables_injected_into_cf_workers"
// - Into a barnacle, the ops_client, or rebate: Add the env var to "export const environment_variables_injected_into_client"

export const dev_mode = process.env.NODE_ENV === `development` as const

export const feature_promos = dev_mode

export const aws_sqs_auth = {
	region: `us-east-2`,
	user: `sqs-dev-access`,
	access_key_id: process.env.AWS_ACCESS_KEY_ID as string,
	secret_access_key: process.env.AWS_SECRET_ACCESS_KEY as string,
} as const

export const sqs_queue_url_prefix = `https://sqs.us-east-2.amazonaws.com/091565997128/`

export const prod_task_worker_queue_name = `prod_task_worker`
export const prod_task_worker_slow_queue_name = `prod_task_worker_slow`

export const prod_task_worker_queue_url = sqs_queue_url_prefix + prod_task_worker_queue_name
export const prod_task_worker_slow_queue_url = sqs_queue_url_prefix + prod_task_worker_slow_queue_name

const prod_task_worker_dead_letter_queue_name = `prod_task_worker_dead_letter`
const prod_task_worker_slow_dead_letter_queue_name = `prod_task_worker_slow_dead_letter`
const staging_task_worker_queue_name = `staging_task_worker`

export const prod_task_worker_dead_letter_queue_url = sqs_queue_url_prefix + prod_task_worker_dead_letter_queue_name
export const prod_task_worker_slow_dead_letter_queue_url = sqs_queue_url_prefix + prod_task_worker_slow_dead_letter_queue_name
export const staging_task_worker_queue_url = sqs_queue_url_prefix + staging_task_worker_queue_name

export const qbo_prod = {
	base_url: `https://quickbooks.api.intuit.com`,
	realm_id: `9130347992790966`,
	client_id: process.env.QBO_CLIENT_ID,
	client_secret: process.env.QBO_CLIENT_SECRET,
}

export const qbo_sandbox = {
	base_url: `https://sandbox-quickbooks.api.intuit.com`,
	realm_id: `4620816365084756790`,
	client_id: process.env.QBO_SANDBOX_CLIENT_ID,
	client_secret: process.env.QBO_SANDBOX_CLIENT_SECRET,
}

export const sentry_api_dsn = `https://eb41aed8ce954567a68374eee3a39fc2@o400057.ingest.sentry.io/5258098`
export const sentry_taskmaster_dsn = `https://3294898fcd02485f9a5d0820ed2bef5e@o400057.ingest.sentry.io/5398875`
export const sentry_back_client_dsn = `https://2ff32901035e4abdb815f3e097c6703d@o400057.ingest.sentry.io/5258302`
export const sentry_back_server_dsn = `https://d9486877301f4d95bcba187bccb38fa1@o400057.ingest.sentry.io/5281764`
export const sentry_cf_worker_dsn = `https://f05cfe13453641bba5506eb25ac2414d@o400057.ingest.sentry.io/6508589`
export const sentry_release = process.env.CIRCLE_SHA1

export const discord_bot_token = process.env.DISCORD_BOT_TOKEN
export const discord_trex_channel_id = `704167112368717947`

export const operations_prefix = process.env.OPERATIONS_PREFIX
	|| `https://operations.trex-arms.com`
export const operations_api2_prefix = operations_prefix + `/api2`

export const operations_new_client_path_prefix = `/ops_client`
export const operations_index_prefix = `${ operations_prefix }${ operations_new_client_path_prefix }/index.html#`
export const operations_app_prefix = `${ operations_index_prefix }/app`

export const operations_browser_api_prefix = process.env.OPERATIONS_BROWSER_API_PREFIX
	|| `https://operations.trex-arms.com/api`

export const storefront_prefix = process.env.STOREFRONT_PREFIX
	|| `https://www.trex-arms.com`
export const storefront_api2_prefix = (process.env.STOREFRONT_API_HOST || storefront_prefix) + `/api2`
export const storefront_api_prefix = process.env.STOREFRONT_API_PREFIX
	|| `https://www.trex-arms.com/api/front`

export const local_wordpress_address_behind_proxy = process.env.LOCAL_WORDPRESS_ADDRESS_BEHIND_PROXY

export const img_prefix = process.env.IMG_PREFIX
	|| `https://img.trex-arms.com`

export const static_url = process.env.STATIC_URL || `https://static.trex-arms.com`
export const static_prefix = process.env.STATIC_PREFIX
	|| `https://www.trex-arms.com/s/`

export const operations_client_url = process.env.OPERATIONS_CLIENT_URL || `${ static_url }${ operations_new_client_path_prefix }`

export const api_address = process.env.API_ADDRESS
	|| `https://api_proxied.trex-arms.com`

export const api_port = process.env.API_PORT || 4001

export const sparkpost_key = process.env.SPARKPOST_KEY

export const developer_email_account = process.env.DEVELOPER_EMAIL_ACCOUNT || null

export const wordpress_key = process.env.WORDPRESS_KEY || `wordpress_key`

export const emailoctopus_key = process.env.EMAILOCTOPUS_KEY

export const mux_token_id = process.env.MUX_TOKEN_ID
export const mux_secret_key = process.env.MUX_SECRET_KEY
// The default key is the production token.  Devs probably want to override this
// to prevent inflating view counts while testing
export const mux_environment_token = process.env.MUX_ENVIRONMENT_TOKEN || `bb7audlll0bl0mapqnovg2cq3`

export const mysql = {
	host: process.env.MYSQL_HOST,
	port: process.env.MYSQL_PORT ? parseInt(process.env.MYSQL_PORT, 10) : 3306,
	user: process.env.MYSQL_USER,
	password: process.env.MYSQL_PASSWORD,
	database: process.env.MYSQL_DATABASE,
	use_ssl: !dev_mode,
} as const

export const mysql_storefront = {
	host: process.env.MYSQL_HOST,
	port: process.env.MYSQL_PORT,
	user: process.env.STOREFRONT_MYSQL_USER,
	password: process.env.STOREFRONT_MYSQL_PASSWORD,
	database: process.env.MYSQL_DATABASE,
	use_ssl: !dev_mode,
} as const

export const mysql_api = {
	host: process.env.MYSQL_HOST,
	port: process.env.MYSQL_PORT,
	user: process.env.API_MYSQL_USER,
	password: process.env.API_MYSQL_PASSWORD,
	database: process.env.MYSQL_DATABASE,
	use_ssl: !dev_mode,
} as const

// Used for scripts, so devs can run stuff against prod without changing all their MYSQL_* vars in .env
export const mysql_prod = {
	host: process.env.MYSQL_PROD_HOST as string,
	port: parseInt(process.env.MYSQL_PROD_PORT || ``, 10),
	user: process.env.MYSQL_PROD_USER as string,
	password: process.env.MYSQL_PROD_PASSWORD as string,
	database: process.env.MYSQL_PROD_DATABASE as string,
	use_ssl: true,
} as const

export const mysql_taskmaster = {
	host: process.env.MYSQL_HOST,
	port: process.env.MYSQL_PORT,
	user: process.env.TASKMASTER_MYSQL_USER,
	password: process.env.TASKMASTER_MYSQL_PASSWORD,
	database: process.env.MYSQL_DATABASE,
	use_ssl: !dev_mode,
} as const

export const mysql_woocommerce = {
	host: process.env.WOOCOMMERCE_MYSQL_HOST,
	port: process.env.WOOCOMMERCE_MYSQL_PORT,
	user: process.env.WOOCOMMERCE_MYSQL_USER,
	password: process.env.WOOCOMMERCE_MYSQL_PASSWORD,
	database: process.env.WOOCOMMERCE_MYSQL_DATABASE,
	use_ssl: !dev_mode,
} as const

export const mysql_replica_readonly = {
	host: process.env.MYSQL_REPLICA_READONLY_HOST as string,
	port: parseInt(process.env.MYSQL_REPLICA_READONLY_PORT || ``, 10),
	user: process.env.MYSQL_REPLICA_READONLY_USER as string,
	password: process.env.MYSQL_REPLICA_READONLY_PASSWORD as string,
	database: process.env.MYSQL_REPLICA_READONLY_DATABASE as string,
	use_ssl: process.env.MYSQL_REPLICA_READONLY_USE_SSL
		? !!Number(process.env.MYSQL_REPLICA_READONLY_USE_SSL)
		: !dev_mode,
} as const

export const lob = {
	secret_key: process.env.LOB_SECRET_API_KEY as string,
	bank_account: process.env.LOB_BANK_ACCOUNT as string,
	from_address: process.env.LOB_FROM_ADDRESS as string,
} as const

export const api_digitalocean_spaces = {
	img_path: `https://trexarms-img.nyc3.digitaloceanspaces.com`,
	key: process.env.API_DIGITALOCEAN_SPACES_KEY as string,
	secret: process.env.API_DIGITALOCEAN_SPACES_SECRET as string,
} as const

export const cloudflare = {
	account_id: process.env.CLOUDFLARE_ACCOUNT_ID || `5ad0591fd4e55c413f4967e21b92dfe7`,
	zone_id: process.env.CLOUDFLARE_ZONE_ID || `667acb143ff7a57689f79fdecd35cf13`,
	auth_email: process.env.CLOUDFLARE_AUTH_EMAIL,
	auth_key: process.env.CLOUDFLARE_AUTH_KEY,
} as const

export const cloudflare_cache_purge_token = process.env.CLOUDFLARE_CACHE_PURGE_TOKEN
export const cloudflare_redirects_token = process.env.CLOUDFLARE_REDIRECTS_TOKEN

export const authorize_net_ecrypt = {
	subdomain: `api`, // if you make this an env var, then Circle CI will redact every instance of "api"
	login_id: process.env.AUTHORIZE_NET_ECRYPT_LOGIN_ID,
	key: process.env.AUTHORIZE_NET_ECRYPT_KEY,
} as const

export const authorize_net_elavon = {
	subdomain: `api`, // if you make this an env var, then Circle CI will redact every instance of "api"
	login_id: process.env.AUTHORIZE_NET_ELAVON_LOGIN_ID,
	key: process.env.AUTHORIZE_NET_ELAVON_KEY,
} as const

export const authorize_net_keys = {
	AUTHORIZE_NET_ELAVON_KEY: process.env.AUTHORIZE_NET_ELAVON_KEY,
	AUTHORIZE_NET_ECRYPT_KEY: process.env.AUTHORIZE_NET_ECRYPT_KEY,
} as const

export const authorize_net_sandbox = {
	subdomain: `apitest`,
	login_id: process.env.AUTHORIZE_NET_SANDBOX_LOGIN_ID,
	key: process.env.AUTHORIZE_NET_SANDBOX_KEY,
} as const

export const apple_pay_certificate = {
	certificate: (process.env.APPLE_PAY_CERTIFICATE || ``).replace(/\\n/g, `\n`),
} as const

export const taxjar_api_live = {
	prefix: `https://api.taxjar.com`,
	token: process.env.TAXJAR_API_TOKEN as string,
} as const

export const taxjar_api_sandbox = {
	prefix: `https://api.sandbox.taxjar.com`,
	token: process.env.TAXJAR_API_SANDBOX_TOKEN as string,
} as const

export const api2pdf_api_key = process.env.API2PDF_API_KEY

export const openai_api_key = process.env.OPENAI_API_KEY

export const cloudflare_ssl_keys = {
	key: (process.env.CLOUDFLARE_SSL_PRIVATE_KEY || ``).replace(/\\n/g, `\n`),
	cert: (process.env.CLOUDFLARE_SSL_PUBLIC_KEY || ``).replace(/\\n/g, `\n`),
} as const

export const nofraud_api_live = {
	url: `https://api.nofraud.com`,
	token: process.env.NOFRAUD_API_TOKEN,
} as const

export const nofraud_api_test = {
	url: `https://apitest.nofraud.com`,
	token: process.env.NOFRAUD_TEST_API_TOKEN,
} as const

export const nofraud_webhook_token = process.env.NOFRAUD_WEBHOOK_TOKEN

export const shipstation_webhook_token = process.env.SHIPSTATION_WEBHOOK_TOKEN

export const google_analytics_tag_id = `G-JPWR5TMVMT`

export const tableau_restricted = {
	account_email: `austin.powell@trex-arms.com`,
	client_id: `e43ac2b6-1beb-4f2d-8a7b-c61046c86a7c`,
	secret_id: `629bc02f-29bd-45bd-bf0b-fb2ada6990d6`,
	secret_key: process.env.TABLEAU_RESTRICTED_SECRET_KEY as string,
}

export const tableau_unrestricted = {
	account_email: `austin.powell@trex-arms.com`,
	client_id: `3f908781-917d-45cf-a936-3bb7327d4bbd`,
	secret_id: `1f53a031-10aa-434e-9ae3-4b63ea1e194b`,
	secret_key: process.env.TABLEAU_UNRESTRICTED_SECRET_KEY as string,
}

// we control these during big sale events, like Black Friday
export const should_split_between_buildings = false
export const should_split_multi_holster_orders = true
// an order that contains retail, holsters, AND clearance items is too complicated.
// this basically turns on should_split_between_buildings when an order contains clearance items.
export const should_split_clearance_between_buildings = true
export const should_split_clearance_always = true
// TODO: instead of hardcoding these booleans, we should control them in our configuration table
//     INSERT INTO configuration SET `key` = 'SPLIT_DOMESTIC_ORDERS_BETWEEN_BUILDINGS', `value` = '0';
//     INSERT INTO configuration SET `key` = 'SPLIT_DOMESTIC_MULTI_HOLSTER_ORDERS', `value` = '0';
//     INSERT INTO configuration SET `key` = 'SPLIT_INTERNATIONAL_ORDERS_BETWEEN_BUILDINGS', `value` = '0';
//     INSERT INTO configuration SET `key` = 'SPLIT_INTERNATIONAL_MULTI_HOLSTER_ORDERS', `value` = '0';
